/**
 * Checks if given action item should be displayed
 *
 * @param {string} action
 * @param {BobTVUser} user
 * @param {BobTVUser} currentUser
 * @return {boolean}
 */
export default function itemVisible(action, user, currentUser) {
    let myself = (user.ufrag === currentUser.ufrag);

    if (currentUser.isAnonymous() && ["pm", "view", "profile", "virtual_gift", "give_xxl", "follow", "block", "unblock", "exclude"].indexOf(action) == -1) {
        return false;
    }

    if (myself) {
        return (action == "view" || action == "profile");
    }

    if (user.online === false && ["view", "pm"].indexOf(action) != -1) {
       // return false;
    }

    if (action == "pm") {
        return true;
    }

    if (action == "follow") {
        return !currentUser.isUserFollowed(user);
    }

    if (action == "unfollow") {
        return currentUser.isUserFollowed(user);
    }

    if (action == "block") {
        if (user.isAdmin()) return false;
        if (currentUser.isUserBlocked(user)) return false;

        return true;
    }

    if (action == "unblock") {
        if (user.isAdmin()) return false;
        if (!currentUser.isUserBlocked(user)) return false;
    }

    if (action == "exclude") {
        return !user.isAdmin() && currentUser.isXXL();
    }

    if (action == "ban") {
        return currentUser.isOwner();
    }

    if (action == "mention") {
        return currentUser.isCertified();
    }

    return true;
}



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UserContextMenu/itemVisible.js